import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '天地大课堂 活动中成长';
const BASE_NAME = '2022TDDKT';
const route: RouteConfig = {
  path: '/2022TDDKT',
  name: BASE_NAME,
  component: () => import('./Home.vue'),
  redirect: `/${BASE_NAME}/First`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'First',
      component: () => import('./First.vue'),
      name: BASE_NAME + 'First',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: BASE_NAME + 'Detail',
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: BASE_NAME + 'ListPage',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'SearchPage',
      component: () => import('./SearchPage.vue'),
      name: BASE_NAME + 'SearchPage',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'User',
      component: () => import('./User.vue'),
      name: BASE_NAME + 'User',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
